import { getQBankStructureLevelLabelByCategory } from '@exam-management/common/utils';
import {
  findPreviousEnabledLevel,
  type QBankStructureLevel,
  type QBankStructureLevelItemWithLevel,
} from '@exam-management/qbs-provider';
import { FormSearchSelection, type OptionSelectionProps } from '@shared/components';
import { useFormContext } from 'react-hook-form';

import { getOptionsByPreviousLevelItemId } from './utils';

export interface LocationFormFieldsProps {
  qbsLevels: QBankStructureLevel[];
  qbsLevelItems: QBankStructureLevelItemWithLevel[];
  prefix?: string;
  allowSkipLevel?: boolean;
}

export default function LocationFormFields(props: Readonly<LocationFormFieldsProps>) {
  const { qbsLevels, qbsLevelItems, prefix, allowSkipLevel: isAllowSkipLevel = false } = props;

  const formContext = useFormContext();

  const namePrefix = prefix ? `${prefix}.` : '';

  return (
    <>
      {qbsLevels.map((qbsLevel) => {
        const name = `${namePrefix}${qbsLevel.category}`;
        const label = getQBankStructureLevelLabelByCategory(qbsLevel.category, {
          withEng: true,
        });

        const previousEnabledLevel = findPreviousEnabledLevel(qbsLevels, qbsLevel.id);

        const previousLevelSelectedItem =
          previousEnabledLevel === null
            ? null
            : (formContext.watch(
                `${namePrefix}${previousEnabledLevel.category}`,
              ) as OptionSelectionProps | null);

        const isLevelDisabled = !qbsLevel.enabled;

        const isSelectionDisabledDueToPreviousLevel =
          !previousLevelSelectedItem &&
          qbsLevel.level !== 2 &&
          previousEnabledLevel?.level !== undefined;

        const shouldDisabled =
          isLevelDisabled || (isSelectionDisabledDueToPreviousLevel && !isAllowSkipLevel);

        const optionsByLevel = getOptionsByPreviousLevelItemId(
          (previousLevelSelectedItem?.value ?? null) as string | null,
          qbsLevel.level,
          qbsLevelItems,
        );

        const placeholder = !qbsLevel.enabled
          ? 'ไม่เปิดใช้งาน'
          : `เลือก${getQBankStructureLevelLabelByCategory(qbsLevel.category)}`;

        const nextLevels = qbsLevels.filter((level) => level.level > qbsLevel.level);

        return (
          <FormSearchSelection
            name={name}
            key={qbsLevel.category}
            required
            label={label}
            options={optionsByLevel}
            disabled={shouldDisabled}
            placeholder={placeholder}
            onChange={() => {
              for (const nextLevel of nextLevels) {
                formContext.setValue(`${namePrefix}${nextLevel.category}`, null);
              }
            }}
          />
        );
      })}
    </>
  );
}
